module.exports = __webpack_public_path__ + "static/media/swans-landing.64394959.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/swans-landing.jpg
// module id = 133
// module chunks = 0